var _window$location, _window$location2;
var apiEndpointsMap = [{
  name: 'local',
  primary: 'http://local.verisure.com:8081',
  failover: 'http://local.verisure.com:8081'
}, {
  name: 'test',
  primary: 'https://galactica-mypages-api01.dev.verisure.com',
  failover: 'https://galactica-mypages-api02.dev.verisure.com'
}, {
  name: 'kobol',
  primary: 'https://kobol-mypages-api01.dev.verisure.com',
  failover: 'https://kobol-mypages-api02.dev.verisure.com'
}, {
  name: 'caprica',
  primary: 'https://caprica-mypages-api01.dev.verisure.com',
  failover: 'https://caprica-mypages-api02.dev.verisure.com'
}, {
  name: 'systest',
  primary: 'https://mypages-api01.sys.verisure.com',
  failover: 'https://mypages-api02.sys.verisure.com'
}, {
  name: 'production',
  primary: 'https://mypages-api01.verisure.com',
  failover: 'https://mypages-api02.verisure.com'
}];
var getCurrentEnvironment = function getCurrentEnvironment(hostname) {
  var environment = '';
  switch (hostname) {
    case 'localhost':
      environment = 'local';
      break;
    case 'galactica-oauth.dev.verisure.com':
    case 'galactica-mypages.dev.verisure.com':
    case 'local-mypages.verisure.com':
    case 'mypages.local.verisure.com':
    case 'local.verisure.com':
      environment = 'test';
      break;
    case 'kobol-mypages.dev.verisure.com':
      environment = 'kobol';
      break;
    case 'caprica-mypages.dev.verisure.com':
    case 'caprica-stagemypages.dev.verisure.com':
      environment = 'caprica';
      break;
    case 'oauth.sys.verisure.com':
    case 'mypages.sys.verisure.com':
      environment = 'systest';
      break;
    case 'oauth.verisure.com':
    case 'mypages.verisure.com':
      environment = 'production';
      break;
    default:
      environment = 'UNKNOWN ENVIRONMENT';
  }
  return environment;
};
var getHostName = function getHostName() {
  return window && window.location && window.location.hostname;
};
var apiEndpoint = function apiEndpoint(hostname) {
  return apiEndpointsMap.find(function (endpoint) {
    return endpoint.name === getCurrentEnvironment(hostname);
  });
};
var isInProduction = getCurrentEnvironment((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) === 'production' || getCurrentEnvironment((_window$location2 = window.location) === null || _window$location2 === void 0 ? void 0 : _window$location2.hostname) === 'systest';

export { apiEndpoint, getCurrentEnvironment, getHostName, isInProduction };
